import React from "react";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();

  const handleAppointmentClick = (e) => {

    // Agar already Contact page par hain
    if (location.pathname === "/contact") {
      e.preventDefault();

      const formSection = document.getElementById("contact-form");

      if (formSection) {
        formSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  };

  return (
    <footer className="tanya-footer">

      {/* ================= FOOTER MAIN ================= */}
      <div className="tanya-footer-container">


        {/* ================= BRAND ================= */}
        <div className="tanya-footer-brand">

          <div className="tanya-footer-brand-logo">

            <div className="tanya-footer-logo-circle">
              M
            </div>

            <div className="tanya-footer-brand-name">
              <h2>Makeup by Tanya</h2>
              <span>BEAUTY · COSMETICS</span>
            </div>

          </div>


          <p className="tanya-footer-description">
            Discover beauty, elegance and confidence with Makeup by Tanya.
            From flawless makeup looks to premium beauty products,
            everything is created to make you feel truly beautiful.
          </p>


          {/* ================= SOCIAL ICONS ================= */}
          <div className="tanya-footer-socials">

            {/* WhatsApp 1 */}
            <a
              href="https://wa.me/918595644307"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp 8595644307"
            >
              <svg viewBox="0 0 24 24">

                <path
                  d="M20.5 11.2a8.5 8.5 0 0 1-12.7 7.4L4 20l1.5-3.6A8.5 8.5 0 1 1 20.5 11.2z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                />

                <path
                  d="M8.5 8.5c.3-.5.6-.5.9-.5h.5c.2 0 .4.1.5.4l.7 1.6c.1.2.1.4 0 .6l-.5.7c-.1.2-.1.4 0 .6.5.9 1.3 1.6 2.2 2.1.2.1.4.1.6-.1l.7-.8c.2-.2.4-.2.7-.1l1.5.7c.3.1.4.3.4.5v.5c0 .3-.1.6-.4.8-.4.3-1 .5-1.6.4-1.1-.2-2.4-.9-3.6-2.1-1.2-1.2-1.9-2.4-2.1-3.5-.1-.6.1-1.2.5-1.8z"
                  fill="currentColor"
                />

              </svg>
            </a>


            {/* WhatsApp 2 */}
            <a
              href="https://wa.me/917834923166"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp 7834923166"
            >
              <svg viewBox="0 0 24 24">

                <path
                  d="M20.5 11.2a8.5 8.5 0 0 1-12.7 7.4L4 20l1.5-3.6A8.5 8.5 0 1 1 20.5 11.2z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                />

                <path
                  d="M8.5 8.5c.3-.5.6-.5.9-.5h.5c.2 0 .4.1.5.4l.7 1.6c.1.2.1.4 0 .6l-.5.7c-.1.2-.1.4 0 .6.5.9 1.3 1.6 2.2 2.1.2.1.4.1.6-.1l.7-.8c.2-.2.4-.2.7-.1l1.5.7c.3.1.4.3.4.5v.5c0 .3-.1.6-.4.8-.4.3-1 .5-1.6.4-1.1-.2-2.4-.9-3.6-2.1-1.2-1.2-1.9-2.4-2.1-3.5-.1-.6.1-1.2.5-1.8z"
                  fill="currentColor"
                />

              </svg>
            </a>


            {/* Instagram */}
            <a
              href="https://www.instagram.com/tanyaaggarwalmakeup?stkn=czZrdjRhejBuMnp6&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <svg viewBox="0 0 24 24">

                <rect
                  x="3"
                  y="3"
                  width="18"
                  height="18"
                  rx="5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                />

                <circle
                  cx="12"
                  cy="12"
                  r="4"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                />

                <circle
                  cx="17.5"
                  cy="6.5"
                  r="1"
                  fill="currentColor"
                />

              </svg>
            </a>


            {/* YouTube */}
            <a
              href="https://youtube.com/@tanyaaggarwal1399?si=E_XEtkCIokXBG9x9"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <svg viewBox="0 0 24 24">

                <path
                  d="M21.5 7.2a2.8 2.8 0 0 0-2-2C17.8 4.7 12 4.7 12 4.7s-5.8 0-7.5.5a2.8 2.8 0 0 0-2 2C2 8.9 2 12 2 12s0 3.1.5 4.8a2.8 2.8 0 0 0 2 2c1.7.5 7.5.5 7.5.5s5.8 0 7.5-.5a2.8 2.8 0 0 0 2-2c.5-1.7.5-4.8.5-4.8s0-3.1-.5-4.8z"
                  fill="currentColor"
                />

                <path
                  d="M10 15.5 15 12l-5-3.5v7z"
                  fill="#0d080b"
                />

              </svg>
            </a>

          </div>

        </div>


        {/* ================= QUICK LINKS ================= */}
        <div className="tanya-footer-column">

          <h3>Quick Links</h3>

          <div className="tanya-footer-line"></div>

          <Link to="/">Home</Link>
          <Link to="/about">About Us</Link>
          <Link to="/services">Services</Link>
          <Link to="/products">Our Products</Link>
          <Link to="/contact">Contact</Link>

        </div>


        {/* ================= SERVICES ================= */}
        <div className="tanya-footer-column">

          <h3>Our Services</h3>

          <div className="tanya-footer-line"></div>

          <Link to="/services#bridal">
            Bridal Makeup
          </Link>

          <Link to="/services#party">
            Party Makeup
          </Link>

          <Link to="/services#artist">
            Makeup Artist
          </Link>

          <Link to="/services#consultation">
            Beauty Consultation
          </Link>

          <Link to="/services#skincare">
            Skincare
          </Link>

        </div>


        {/* ================= CONTACT ================= */}
        <div className="tanya-footer-column tanya-footer-contact">

          <h3>Get In Touch</h3>

          <div className="tanya-footer-line"></div>


          {/* Location */}
          <div className="tanya-contact-item">

            <div className="tanya-contact-icon">

              <svg viewBox="0 0 24 24">
                <path
                  d="M12 21s7-6.1 7-12a7 7 0 1 0-14 0c0 5.9 7 12 7 12z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                />

                <circle
                  cx="12"
                  cy="9"
                  r="2.2"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                />
              </svg>

            </div>

            <span>
              Your Location
              <br />
              India, Delhi
            </span>

          </div>


          {/* Phone */}
          <div className="tanya-contact-item">

            <div className="tanya-contact-icon">

              <svg viewBox="0 0 24 24">
                <path
                  d="M6 3h4l2 5-2.5 1.5a15 15 0 0 0 5 5L16 12l5 2v4c0 1.1-.9 2-2 2C10.7 20 4 13.3 4 5a2 2 0 0 1 2-2z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                  strokeLinejoin="round"
                />
              </svg>

            </div>

            <span>
              <a href="tel:+918595644307">
                +91 8595644307
              </a>

              <br />

              <a href="tel:+917834923166">
                +91 7834923166
              </a>
            </span>

          </div>


          {/* Email */}
          <div className="tanya-contact-item">

            <div className="tanya-contact-icon">

              <svg viewBox="0 0 24 24">

                <rect
                  x="3"
                  y="5"
                  width="18"
                  height="14"
                  rx="2"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                />

                <path
                  d="m4 7 8 6 8-6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                />

              </svg>

            </div>

            <span>
              <a href="mailto:aggarwalt426@gmail.com">
                aggarwalt426@gmail.com
              </a>
            </span>

          </div>


          {/* ================= APPOINTMENT ================= */}
          <Link
            to="/contact"
            className="tanya-footer-appointment"
            onClick={handleAppointmentClick}
          >

            <span>
              Book an Appointment
            </span>

            <svg viewBox="0 0 24 24">

              <path
                d="M5 12h14M13 6l6 6-6 6"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />

            </svg>

          </Link>

        </div>

      </div>


      {/* ================= FOOTER BOTTOM ================= */}
      <div className="tanya-footer-bottom">

        <div className="tanya-footer-bottom-inner">

          <p>
            © {new Date().getFullYear()} Makeup by Tanya.
            All Rights Reserved.
          </p>

          <div className="tanya-footer-legal">

            <Link to="/privacy">
              Privacy Policy
            </Link>

            <span></span>

            <Link to="/terms">
              Terms & Conditions
            </Link>

          </div>

        </div>

      </div>

    </footer>
  );
};

export default Footer;